import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';

import { ReactiveFormsModule, Validators } from '@angular/forms';

import { ButtonModule } from 'primeng/button';
import { SelectModule } from 'primeng/select';
import { CheckboxModule } from 'primeng/checkbox';
import { PopoverModule } from 'primeng/popover';

// Composants
import { FormBaseComponent } from 'src/app/@shared/components/abstract/form-base.component';

// Modèles
import { AccountEntryExport } from 'src/app/@shared/models/accounting/account-entry-export.model';
import { AccountEntryExportFormat } from 'src/app/@shared/models/accounting/account-entry-export-format.model';

// Utils
import { Sorter } from 'src/app/@shared/utilities/models/sorter';

@Component({
    selector: 'app-account-entries-export-form',
    imports: [
        CommonModule,
        ReactiveFormsModule,
        ButtonModule,
        CheckboxModule,
        PopoverModule,
        SelectModule
    ],
    templateUrl: './account-entries-export-form.component.html',
    styleUrls: ['./account-entries-export-form.component.scss']
})
export class AccountEntriesExportFormComponent extends FormBaseComponent {

    /*----------------------------------------------------------------------------------------
     * Gestion de la vue
     ----------------------------------------------------------------------------------------*/

    @Output() exportSaved: EventEmitter<void> = new EventEmitter<void>();

    /*----------------------------------------------------------------------------------------
     * Données
     ----------------------------------------------------------------------------------------*/

    private _accountEntryExport!: AccountEntryExport;
    public get accountEntryExport(): AccountEntryExport {
        return this._accountEntryExport;
    }
    @Input()
    public set accountEntryExport(accountEntryExport: AccountEntryExport) {
        this._accountEntryExport = accountEntryExport;
    }

    private _exportFormats: AccountEntryExportFormat[] = [];
    public get exportFormats(): AccountEntryExportFormat[] {
        return this._exportFormats;
    }
    public set exportFormats(formats: AccountEntryExportFormat[]) {
        let emptyArray: AccountEntryExportFormat[] = [];
        this._exportFormats = emptyArray.concat(formats);
    }

    /*----------------------------------------------------------------------------------------
     * Accesseurs
     ----------------------------------------------------------------------------------------*/

    /*----------------------------------------------------------------------------------------
     * Méthodes publiques
     ----------------------------------------------------------------------------------------*/

    public submit(): void {
        this._export();
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes protégées
     ----------------------------------------------------------------------------------------*/

    protected override buildForm(): void {
        this.form = this.formBuilder.group({
            attachments: true,
            compress: false,
            format: [null, Validators.required],
        });
    }

    protected override loadData(): void {
        this._loadExportFormats();
    }

    /*----------------------------------------------------------------------------------------
     * Méthodes privées
     ----------------------------------------------------------------------------------------*/

    private _export() {

        this._mapFromForm();

        this.accountEntryExportService.save$(this.accountEntryExport).subscribe(
            () => {
                this.exportSaved.emit();
                this.router.navigate([this.appService.clientUrl('/accounting/journals/exports')]);
            }
        );
    }

    private _loadExportFormats() {
        this.accountEntryExportFormatService.getList$({
            sorters: [
                new Sorter({
                    property: 'label'
                })
            ]
        }).subscribe(formats => this.exportFormats = formats);
    }

    private _mapFromForm() {
        this.accountEntryExport.attachments = this.form.get('attachments')!.value;
        this.accountEntryExport.compress = this.form.get('attachments')!.value ? this.form.get('compress')!.value : false;
        this.accountEntryExport.format = this.form.get('format')!.value;
    }

}
